<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Environment Details</h1>

<div>
  <!-- Loading -->
  <mat-progress-spinner mode="indeterminate" *ngIf="isLoading"></mat-progress-spinner>

  <!-- Environment -->
  <div *ngIf="environment">
    <pre>{{environment | json}}</pre>
  </div>
  <div>
    <a class="mat-raised-button" [routerLink]="['/erm/customers', environment?.customerId]">View Customer</a>
    <span>&nbsp;</span>
    <a class="mat-raised-button" [routerLink]="['/erm/accounts', environment?.accountId]">View Account</a>
  </div>

  <!-- Alarms -->
  <mat-toolbar>
    <h2>Alarms</h2>
    <span class="spacer"></span>
  </mat-toolbar>
  <div class="alarmGridContainer">
    <ag-grid-angular #agGrid class="ag-theme-alpine alarmGrid" [gridOptions]="alarmGridOptions">
    </ag-grid-angular>
  </div>

  <!-- Health Checks -->
  <mat-toolbar>
    <h2>Health Checks</h2>
    <span class="spacer"></span>
    <button mat-raised-button (click)="runAllHealthChecks()">
        Run All
    </button>
  </mat-toolbar>
  <div class="healthCheckGridContainer">
    <ag-grid-angular #agGrid class="ag-theme-alpine healthCheckGrid" [gridOptions]="healthCheckGridOptions">
    </ag-grid-angular>
  </div>
</div>
